import React from 'react';
import Navigation from "../../components/navigation";
import {Stack} from "@mui/material";
import {Outlet} from "react-router";
import {HELP_NAV_LINK} from "../../constants/helpNavLink";

const AppManager = () => {

    const navLinks = [
        {destination: "analytics", label: "Ops Insights"},
        {destination: "workflow", label: "Workflow"},
        {destination: "charts", label: "Charts"},
        {destination: "feed", label: "Feeds"},
        {destination: "kb", label: "KB"},
        HELP_NAV_LINK,
    ]

    return (
        <Stack height={'100vh'} overflow={'hidden'}>
            <Navigation navLinks={navLinks}/>
            <Stack flex={1} overflow={'auto'}>
                <Outlet/>
            </Stack>
        </Stack>
    );
};

export default AppManager;